import { __awaiter } from "tslib";
import { EnrichFeatureFlag } from '@groupby/enrich-console';
import { getConfig } from '@/config';
import { FeatureFlagsService } from './feature-flag-service';
import { ProviderType } from './feature-flag-service/feature-flag-service.constants';
import { FeatureFlag } from './feature-flags.constants';
const config = getConfig();
const baseContext = {
    kind: 'multi',
    application: {
        key: 'command-center-ui',
        name: 'command-center-ui',
    },
    configuration: {
        key: config.customer,
        environment: config.customer,
        isUpper: config.environment !== 'lower',
    },
};
export const featureFlagsService = new FeatureFlagsService([ProviderType.QueryParams, ProviderType.LaunchDarkly, ProviderType.FeaturesApi]);
export const initializeFeatureFlagsService = () => __awaiter(void 0, void 0, void 0, function* () {
    yield featureFlagsService.initialize(baseContext);
    // register existing feature flags first
    const featureFlags = [...Object.values(FeatureFlag), ...Object.values(EnrichFeatureFlag)];
    featureFlagsService.registerFeatureFlags(featureFlags);
    const featuresExcludedFromNext = [FeatureFlag.EmojiLang];
    featureFlagsService.excludeFlagsFromNext(featuresExcludedFromNext);
    // load all feature flags and save them to storage
    yield featureFlagsService.setFeatureFlags();
});
